import { Type, type StaticDecode } from 'typebox'

export type StoredAuthenticationContext = StaticDecode<typeof StoredAuthenticationContext>
export const StoredAuthenticationContext = Type.Object({
    loginKind: Type.Union([
        Type.Literal('direct'),
        Type.Literal('oauth'),
        Type.Literal('session-restored')
    ]),
    namespace: Type.String({ minLength: 1 }),
    authenticatedAt: Type.Integer({ minimum: 0 })
})
